import { render, staticRenderFns } from "./LmUserPermissionsUi.vue?vue&type=template&id=35438d50&"
import script from "./LmUserPermissionsUi.vue?vue&type=script&lang=js&"
export * from "./LmUserPermissionsUi.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports